import { render, staticRenderFns } from "./UncheckedBoxIcon.vue?vue&type=template&id=4c9bc0ba&"
import script from "./UncheckedBoxIcon.vue?vue&type=script&lang=js&"
export * from "./UncheckedBoxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports